import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import * as XLSX from 'xlsx';
import { API_URL } from '..';

const ExcelUploadModal = ({ show, onHide }) => {
  const [excelData, setExcelData] = useState([]);
  const [uploadingExcel, setUploadingExcel] = useState(false);

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (evt) => {
        const bstr = evt.target.result;
        const wb = XLSX.read(bstr, { type: 'binary' });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = XLSX.utils.sheet_to_json(ws);
        
        const parsed = [];
        data.forEach(row => {
          if (row.SKU === 'SS-033') {
            parsed.push({
              sku: row.SKU,
              title: `${row.Description || row.Category || ''} - Coil`,
              description: row.Description || '',
              costPrice: row['Coil Rate (PKR)'] || '0',
              sellPrice: row['Coil Rate (PKR)'] || '0',
              quantity: '0',
              color: 'N/A',
              locationId: row.LocationId || '0cfSDOngHJstzV4BZzK2',
              uom: 'Coil'
            });
            parsed.push({
              sku: row.SKU,
              title: `${row.Description || row.Category || ''} - Meter`,
              description: row.Description || '',
              costPrice: row['Meter Rate (PKR)'] || '0',
              sellPrice: row['Meter Rate (PKR)'] || '0',
              quantity: '0',
              color: 'N/A',
              locationId: row.LocationId || '0cfSDOngHJstzV4BZzK2',
              uom: 'Meter'
            });
          } else {
            parsed.push({
              sku: row.SKU || '',
              title: row.Description || row.Category || '',
              description: row.Description || '',
              costPrice: row['Price (PKR)'] || '0',
              sellPrice: row['Price (PKR)'] || '0',
              quantity: '0',
              color: 'N/A',
              locationId: row.LocationId || '0cfSDOngHJstzV4BZzK2',
              uom: row.UOM || ''
            });
          }
        });
        setExcelData(parsed);
      };
      reader.readAsBinaryString(file);
    }
  };

  const submitExcelData = async () => {
    setUploadingExcel(true);
    try {
      const res = await fetch(`${API_URL}/api/invoice/stock/bulk-import`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(excelData),
      });
      if (res.ok) {
        alert('Import successful!');
        window.location.reload();
      } else {
        alert('Import failed.');
      }
    } catch(err) {
      alert('Network error');
    }
    setUploadingExcel(false);
  };

  return (
    <Modal show={show} onHide={onHide} size="xl">
      <Modal.Header closeButton>
        <Modal.Title>Upload Excel Inventory</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <input type="file" accept=".xlsx, .xls, .csv" className="form-control mb-3" onChange={handleFileUpload} />
        {excelData.length > 0 && (
          <div className="table-responsive" style={{ maxHeight: '400px' }}>
            <table className="table table-bordered table-sm">
              <thead>
                <tr>
                  <th>SKU</th>
                  <th>Title</th>
                  <th>UOM</th>
                  <th>Price</th>
                  <th>Location ID</th>
                </tr>
              </thead>
              <tbody>
                {excelData.map((row, idx) => (
                  <tr key={idx}>
                    <td>
                      <input value={row.sku} onChange={(e) => { const newD = [...excelData]; newD[idx].sku = e.target.value; setExcelData(newD); }} className="form-control form-control-sm" />
                    </td>
                    <td>
                      <input value={row.title} onChange={(e) => { const newD = [...excelData]; newD[idx].title = e.target.value; setExcelData(newD); }} className="form-control form-control-sm" />
                    </td>
                    <td>
                      <input value={row.uom} onChange={(e) => { const newD = [...excelData]; newD[idx].uom = e.target.value; setExcelData(newD); }} className="form-control form-control-sm" />
                    </td>
                    <td>
                      <input value={row.sellPrice} onChange={(e) => { const newD = [...excelData]; newD[idx].sellPrice = e.target.value; setExcelData(newD); }} className="form-control form-control-sm" />
                    </td>
                    <td>
                      <input value={row.locationId} onChange={(e) => { const newD = [...excelData]; newD[idx].locationId = e.target.value; setExcelData(newD); }} className="form-control form-control-sm" />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Close</Button>
        <Button variant="primary" onClick={submitExcelData} disabled={uploadingExcel || excelData.length === 0}>
          {uploadingExcel ? 'Importing...' : 'Confirm Import'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ExcelUploadModal;
